export default {
  title: 'Reservierungen aktivieren',
  buttons: {
    cancel: 'Abbrechen',
    activate: 'Reservierungen aktivieren',
  },
};
